import React, { useState, useEffect } from 'react';

const questions = [
  { fraction: '1/2', decimal: 0.5 },
  { fraction: '1/4', decimal: 0.25 },
  { fraction: '3/4', decimal: 0.75 },
  { fraction: '2/5', decimal: 0.4 },
  { fraction: '4/5', decimal: 0.8 },
  { fraction: '3/10', decimal: 0.3 },
  { fraction: '7/10', decimal: 0.7 }
];

const PercentBarGame = () => {
  const [question, setQuestion] = useState({});
  const [sliderValue, setSliderValue] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [emoji, setEmoji] = useState('');

  useEffect(() => {
    generateNewQuestion();
  }, []);

  const generateNewQuestion = () => {
    const q = questions[Math.floor(Math.random() * questions.length)];
    setQuestion(q);
    setSliderValue(0);
    setFeedback('');
    setEmoji('');
  };

  const handleSliderChange = (e) => {
    const value = parseInt(e.target.value);
    setSliderValue(value);

    const decimalValue = value / 100;
    if (Math.abs(decimalValue - question.decimal) < 0.02) {
      setFeedback(`✅ Great job! That's ${value}%`);
      setEmoji("🎉✨🍭");
    } else {
      setFeedback("🔄 Keep trying!");
      setEmoji('');
    }
  };

  const styles = {
    container: {
      fontFamily: "'Comic Sans MS', cursive",
      textAlign: 'center',
      background: 'linear-gradient(to bottom, #fff3e0, #ffe0b2)',
      padding: '30px',
      minHeight: '100vh'
    },
    title: {
      color: '#d84315',
      fontSize: '32px'
    },
    question: {
      fontSize: '24px',
      margin: '20px 0'
    },
    barContainer: {
      width: '80%',
      background: '#fff',
      border: '2px solid #ff7043',
      borderRadius: '20px',
      height: '40px',
      margin: '20px auto',
      overflow: 'hidden',
      boxShadow: 'inset 0 0 10px rgba(0,0,0,0.1)'
    },
    fillBar: {
      height: '100%',
      background: 'linear-gradient(to right, #ff7043, #ffccbc)',
      width: `${sliderValue}%`,
      transition: 'width 0.3s'
    },
    slider: {
      width: '80%',
      marginTop: '20px'
    },
    percentLabel: {
      fontSize: '22px',
      marginTop: '10px',
      color: '#6d4c41'
    },
    feedback: {
      fontSize: '20px',
      margin: '20px',
      fontWeight: 'bold'
    },
    emoji: {
      fontSize: '40px',
      marginTop: '15px'
    },
    nextButton: {
      background: '#ff7043',
      color: 'white',
      fontSize: '18px',
      padding: '10px 20px',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
      marginTop: '20px'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🎯 Fill the Percent Bar</h1>
      <div style={styles.question}>
        What is {question.fraction} as a decimal?
      </div>

      <div style={styles.barContainer}>
        <div style={styles.fillBar}></div>
      </div>

      <input
        type="range"
        min="0"
        max="100"
        value={sliderValue}
        onChange={handleSliderChange}
        style={styles.slider}
      />
      <div style={styles.percentLabel}>{sliderValue}%</div>

      <div style={styles.feedback}>{feedback}</div>
      <div style={styles.emoji}>{emoji}</div>

      <button style={styles.nextButton} onClick={generateNewQuestion}>
        Next ➡
      </button>
    </div>
  );
};

export default PercentBarGame;
